import { height, svgPathData, width } from '@fortawesome/pro-regular-svg-icons/faCalendar'

const BASE_SCALE_AMOUNT = 0.5

export function createClusterElement(value: string, opts: { backgroundColor: string; color: string; scale?: number }) {
  const { backgroundColor = 'grey', color = 'white', scale = 1 } = opts
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" fill="${backgroundColor}" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="95" />
<circle cx="120" cy="120" opacity=".2" r="120" />
<text x="50%" y="50%" style="fill:${color}" text-anchor="middle" font-size="48" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${value}</text>
</svg>`
  const parser = new DOMParser()
  const svgEl = parser.parseFromString(svg, 'image/svg+xml').documentElement
  svgEl.setAttribute('transform', `translate(0 25) scale(${BASE_SCALE_AMOUNT + scale})`)
  return svgEl
}

export function createVisitsAvailableElement() {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" width="50" height="50">
  
<g transform="scale(0.9) translate(${width * 0.05} ${height * 0.05})">
  <path d="${svgPathData}" fill="white" />
</g>
</svg>`
  const parser = new DOMParser()
  const svgEl = parser.parseFromString(svg, 'image/svg+xml').documentElement
  return svgEl
}
